/**
 * 未指定と0を区別する必要がある場合はenumで0を使わないほうが良いが、
 * QuoteBehaviorKindsでは区別する必要が無いのでそのまま0を使っている
 */
export enum QuoteBehaviorKinds {
  Enabled = 0,
  Disabled = 1,
}
